<template>
  <div class="sfq">
    <ul>
      <li v-for="(item, index) in dataList" :key="index" >
        <img class="img" :src="item.bgImg" alt="">
        <a :href="`${item.url ? $Path + item.url : 'javascript:void(0);' }`" class="img-top">
          <img :src="item.img" alt="">
        </a>
        <div class="mark"></div>

        <div class="content">
          <div class="title">{{ item.title }}</div>
          <div class="line"></div>
          <div class="desc">{{ item.desc }}</div>
          <img src="../assets/sfq/right.png" alt="">
        </div>

      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: '',
    components: {},
    props: {},
    data () {
      return {
        dataList: [
          { bgImg: require('../assets/sfq/sfq1.png'), img: require('../assets/sfq/sfq-h1.png'), title: '实木水漆大板', desc: '科技饰面工艺 净味水性漆', url: '/#/family/kechuang' },
          { bgImg: require('../assets/sfq/sfq2.png'), img: require('../assets/sfq/sfq-h2.png'), title: '安芯漆面板', desc: '智能涂层 UV3D面漆', url: '/#/family/anxin' },
          { bgImg: require('../assets/sfq/sfq3.png'), img: require('../assets/sfq/sfq-h3.png'), title: '森格板', desc: '进口材料 极致美感', url: '/#/family/senge' },
          { bgImg: require('../assets/sfq/sfq4.png'), img: require('../assets/sfq/sfq-h4.png'), title: '康芯板', desc: 'ENF级高环保 臻选花色板', url: '/#/family/kangxin' },
          { bgImg: require('../assets/sfq/sfq5.png'), img: require('../assets/sfq/sfq-h5.png'), title: '晶瓷板', desc: '高端饰面 A级防火板', url: '/#/family/jingci' },
          { bgImg: require('../assets/sfq/sfq6.png'), img: require('../assets/sfq/sfq-h6.png'), title: '绿芯胶', desc: '无醛添加高性能 板材专用胶', url: '/#/family/lvxin' },
          { bgImg: require('../assets/sfq/sfq7.png'), img: require('../assets/sfq/sfq-h7.png'), title: '辅 材', desc: '高品质配套物解决方案', url: '/#/family/fucai' }
        ]
      }
    },
    computed: {},
    watch: {},
    created () {},
    mounted () {},
    methods: {}
  }
</script>

<style scoped lang="less">
.sfq{
  width: 100%;
  display: flex;
  justify-content: center;
}
ul{
  width: 100%;
  display: flex;
  padding: 0;
  margin: 0;
  li{
    overflow: hidden;
    position: relative;
    list-style: none;
    flex: 1;
    height: 926px;
    transition: all 0.5s ease-in-out;
    &:nth-of-type(1) {
      .img-top {
        left: 15px;
      }
    }
    .img{
      // width: 100%;
      height: 100%;
      // display: none;
      object-fit: cover;
    }
    .img-top {
      height: 100%;
      position: absolute;
      transform: scale(0.95);
      top: 0;
      left: 0;
      z-index: 4;
      img {
        height: 100%;
        margin-left: -50px;
      }
    }
    .mark {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      z-index: 5;
      background: rgba(0,0,0,.7);
    }
    .content{
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      text-align: center;
      height: 275px;
      padding-top: 120px;
      position: absolute;
      bottom: 0;
      opacity: 0;
      background-image: linear-gradient(180deg, rgba(0,0,0,0), rgba(0,0,0,.8) 100%);
      z-index: 2;
      .title{
        width: 771px;
        font-size: 48px;
        font-weight: 400;
        color: #FFFFFF;
      }
      .line{
        margin-top: 12px;
        display: inline-block;
        width: 100px;
        height: 6px;
        background: #4E8B46;
      }
      .desc{
        width: 771px;
        margin-top: 12px;
        font-size: 28px;
        font-family: FZLanTingHeiS-R-GB;
        font-weight: 400;
        color: #FFFFFF;
      }
      img{
        margin-top: 17px;
        width: 58px;
        height: 59px;
      }
    }
  }
}
ul li:hover{
  flex: 3.3;
  .img-top {
    transform: scale(1);
    transition: all 1s ease-in-out;
  }
  .img{
    display: block;
  }
  .mark {
    display: none;
  }
  .content{
    animation: fadeInUp 0.8s forwards;
    animation-delay: 0.3s;
  }
}

@keyframes up{
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to{
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
